import SidePanelHeader from "../components/SidePanelHeader"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelInfo from "../components/SidePanelInfo"
import { formatAddressString } from "../../../../../helpers/StringHelper";
import EditAction from "../actions/EditAction";
import ActionBar from "../actions/ActionBar";
import { hasVisibleChildren } from "../../../entityComponents/Schema";
import { usePermissions } from "../../../../../modules/auth/Permissions/PermissionContext";
import { hasPermission } from "../../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../../modules/auth/Permissions/PermissionStrings";
import { Button } from "react-aria-components";
import { modalSignal } from "../../../Modal/ModalContainer";
import RemoveModal from "../../../Modal/RemoveModal";
import { SingularUpperCase } from "../../../../../helpers/EntityNameHelper";
import { globalSubmittingSignal } from "../../Layout";

export default function SidePanelCustomers({ data, onViewPage }: any) {
    const navigate = useNavigate()
    const permissionsContext = usePermissions();

    function viewEntity() {
        // Only navigate if there are visible children
        if (hasVisibleChildren(data.entityName, permissionsContext)) {
            Navigation.view.navigate(navigate, data.entityName, data.id, data)
        }
    }

    function handleConfirmDelete() {
        modalSignal.value = <RemoveModal
            heading={`Remove ${SingularUpperCase(data.entityName)}`}
            textLabel="To confirm, enter customer name exactly as shown below"
            expectedConfirmationValue={data.name}
            removeEntity={data.entityName}
            removeId={data.id}
            information="This will permanently delete the customer and any related data. You cannot undo this. Please delete all accounts first if the customer has any."
            ContinueFunc={async () => {}}
        />
    }

    return (<>
        {data &&
            <>
                {!onViewPage && <SidePanelHeader descriptor="" value={data.name} statuses={data.status} onClick={(() => { viewEntity() })} />}
                <ActionBar>
                    {hasPermission(permissionsContext.permissions!, PermissionTypes.write, PermissionConcerns.Customer_Accounts) && 
                        <EditAction id={data.id} entityName={data.entityName} />}
                    {!onViewPage && hasPermission(permissionsContext.permissions!, PermissionTypes.write, PermissionConcerns.Delete_Customer) && 
                        <Button isDisabled={globalSubmittingSignal.value.isBusy} className="button button--small button--primary button--primary--destructive button--with-icon" onPress={handleConfirmDelete}>
                            <p className="button-text">Delete</p>
                        </Button>}
                </ActionBar>
                <SidePanelInfo
                    values={[
                        { label: "Active Accounts", value: data.accountAmount },
                        { label: "Number", value: data.number },
                        { label: "Address", value: formatAddressString(data.address), classname: "whitespace--pre-line" }
                    ]}
                />
                <SidePanelInfo
                    values={[
                        { label: "Telephone", value: data.contactDetails.telephone },
                        { label: "Mobile", value: data.contactDetails.mobile },
                        { label: "Fax", value: data.contactDetails.fax },
                        { label: "Email", value: data.contactDetails.email },
                    ].filter(x => x.value)}
                />
            </>
        }
    </>)


}